export default function Features() {
  const features = [
    {
      icon: 'ri-lock-line',
      color: 'bg-blue-100',
      iconColor: 'text-blue-600',
      title: 'Bank-Level Security',
      description: '256-bit encryption protecting your data across all connections'
    },
    {
      icon: 'ri-speed-line',
      color: 'bg-orange-100',
      iconColor: 'text-orange-600',
      title: 'Lightning Fast Performance',
      description: 'Optimized algorithms ensuring zero lag during operation'
    },
    {
      icon: 'ri-palette-line',
      color: 'bg-purple-100',
      iconColor: 'text-purple-600',
      title: 'Intuitive Design',
      description: 'Clean interface requiring no technical knowledge to operate effectively'
    },
    {
      icon: 'ri-server-line',
      color: 'bg-green-100',
      iconColor: 'text-green-600',
      title: 'Global Server Network',
      description: 'Access to worldwide servers providing optimal connection speeds'
    },
    {
      icon: 'ri-brush-line',
      color: 'bg-amber-100',
      iconColor: 'text-amber-600',
      title: 'Smart Cleaning',
      description: 'Intelligent algorithms identifying and removing unnecessary files safely'
    },
    {
      icon: 'ri-headphone-line',
      color: 'bg-sky-100',
      iconColor: 'text-sky-600',
      title: '24/7 Support',
      description: 'Dedicated team ready to assist with any questions or concerns'
    }
  ];

  return (
    <section id="features" className="py-32 bg-[#F5F5F7]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-24">
          <div className="inline-block px-4 py-2 rounded-full bg-orange-500 mb-6">
            <span className="text-white text-xs uppercase tracking-wider font-medium">// FEATURES</span>
          </div>
          <h2 className="text-6xl font-bold text-black leading-tight">
            Why Choose<br />Our Applications
          </h2>
        </div>

        <div className="grid grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-9 shadow-sm hover:shadow-lg transition-shadow duration-300"
            >
              <div className={`w-12 h-12 rounded-full ${feature.color} flex items-center justify-center mb-6`}>
                <i className={`${feature.icon} ${feature.iconColor} text-xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-black mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-base leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
